import React from "react";
import BrandStyleSheet from "./BrandStyleSheet";

const ErrorPage = (props) => {
  window.scrollTo(0, 0);
  return (
    <div
      id="error"
      className="min-h-full flex flex-col w-full justify-end bg-origin-content bg-center bg-no-repeat bg-cover bg-red-200"
      style={{
        backgroundColor: "#b42c21",
        backgroundImage: `url(${props.backgroundImage})`,
      }}>
      <BrandStyleSheet brandStyleSheet={props.brandStyleSheet} />
      <div
        className=" h-full flex flex-col w-full justify-end"
        style={{
          background:
            "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.0), rgba(0,0,0,1) 100%)",
          maxHeight: "600px",
          minHeight: "500px",
        }}>
        <div className="text-white w-full py-20">
          <div className="max-w-xl mx-auto">
            <h2
              className="type-title xxLarge mb-5 uppercase px-5"
              style={{ color: "#ffffff", lineHeight: "inherit" }}>
              {props.title}
            </h2>
            <p
              className="type-regular normal mb-8 px-5"
              style={{ color: "#ffffff" }}>
              {props.description}
            </p>
            <button
              className={`app-button-desktop type-title medium ${props.buttonStyleName}`}
              style={{
                color: props.appHomeTextCallToAction || "#ffffff",
                backgroundColor: props.backgroundColorTopBar || "red",
              }}
              onClick={props.backLink}>
              {props.backText}
            </button>
          </div>
        </div>
      </div>
      <button
        className="md:hidden uppercase text-white type-title medium text-center w-full py-6"
        style={{
          color: props.appHomeTextCallToAction || "#ffffff",
          backgroundColor: props.backgroundColorTopBar || "red",
        }}
        onClick={() => props.backLink()}>
        {props.backText}
      </button>
    </div>
  );
};

export default ErrorPage;
